(function(){
  /* mobile menu */
  var menu = document.getElementById('KevytMenu');
  var burger = document.getElementById('KevytBurger');
  var close = document.getElementById('KevytMenuClose');
  if (menu && burger && close) {
    function openMenu(){ menu.showModal(); document.body.style.overflow='hidden'; }
    function closeMenu(){ menu.close(); document.body.style.overflow=''; }
    burger.addEventListener('click', openMenu);
    close.addEventListener('click', closeMenu);
    menu.addEventListener('click', function(e){ if (e.target === menu) closeMenu(); });
    menu.addEventListener('close', function(){ document.body.style.overflow=''; });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });
  }

  /* sticky bottom CTA bar: reveals after the hero leaves the viewport,
     hides while the purchase card or footer is on screen. Transform-only,
     so it can never cause layout shift. */
  var bar = document.getElementById('KevytStickyBar');
  var hero = document.querySelector('.kv-hero');
  if (bar && hero && 'IntersectionObserver' in window) {
    var heroGone = false;
    var blockedBy = new Map();
    function update(){
      var blocked = false;
      blockedBy.forEach(function(v){ if (v) blocked = true; });
      bar.classList.toggle('on', heroGone && !blocked);
    }
    new IntersectionObserver(function(en){
      var e = en[0];
      heroGone = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }, {threshold: 0}).observe(hero);
    var zones = [document.getElementById('osta'), document.querySelector('.kv-foot')].filter(Boolean);
    if (zones.length) {
      var zio = new IntersectionObserver(function(en){
        en.forEach(function(e){ blockedBy.set(e.target, e.isIntersecting); });
        update();
      }, {threshold: 0});
      zones.forEach(function(z){ zio.observe(z); });
    }
  }
})();
